module.exports = __webpack_public_path__ + "img/C04TechMarksmanship_ua.934eaae8.webp";